import { BN } from "@project-serum/anchor";
import { nativeToUi as uxdNativeToUi } from "@uxd-protocol/uxd-client";

export const BN_ZERO = new BN(0);
export const BN_ONE = new BN(1);

export function nativeToUi(nativeAmount: BN, decimals: number): number {
  return uxdNativeToUi(nativeAmount, decimals);
}
